// Slack Digest API helpers
const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

// Get digest settings for a brand
export async function getDigestSettings(brandId) {
  const res = await fetch(`${API_BASE}/api/v1/integrations/slack/digest/settings?brand_id=${encodeURIComponent(brandId)}`, {
    headers: { "X_ADMIN_TOKEN": "dev" }
  });
  if (!res.ok) {
    if (res.status === 404) return null;
    throw new Error(await res.text());
  }
  return res.json();
}

// Set digest settings (enable/disable, schedule, thresholds)
export async function setDigestSettings({ brandId, teamId, enabled, day, hourUtc, thresholds }) {
  const res = await fetch(`${API_BASE}/api/v1/integrations/slack/digest/settings`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X_ADMIN_TOKEN": "dev"
    },
    body: JSON.stringify({
      brand_id: brandId,
      team_id: teamId,
      enabled,
      day,
      hour_utc: hourUtc,
      thresholds
    })
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

// Run digest now (for testing)
export async function runDigestNow({ brandId, force = false }) {
  const url = new URL(`${API_BASE}/api/v1/integrations/slack/digest/run`);
  if (brandId) url.searchParams.set('brand_id', brandId);
  if (force) url.searchParams.set('force', 'true');
  
  const res = await fetch(url.toString(), {
    method: "POST",
    headers: { "DIGEST_RUN_TOKEN": "dev" }
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

// Get delivery log
export async function getDigestDeliveries(brandId, limit = 50, statusFilter = null) {
  const url = new URL(`${API_BASE}/api/v1/integrations/slack/digest/deliveries`);
  url.searchParams.set('brand_id', brandId);
  url.searchParams.set('limit', limit.toString());
  if (statusFilter) url.searchParams.set('status_filter', statusFilter);
  
  const res = await fetch(url.toString(), {
    headers: { "X_ADMIN_TOKEN": "dev" }
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}
